import React, { useEffect, useState } from "react";
import { Breadcrumb, Button, Card, Col, Row, Stack } from "react-bootstrap";
import { MdHandshake, MdSupervisorAccount } from "react-icons/md";
import { MatDataGrid } from "../../../components/common/dataGrid/DataGrid";
import { ActionCell } from "../../../components/common/dataGrid/ActionCell";
import { SwitchCell } from "../../../components/common/dataGrid/SwitchCell";
import { Box, TextField } from "@mui/material";
import CustomSelect from "../../../components/common/CustomSelect";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
  getUserListAPI,
  changeUserStatus,
  deleteUser,
} from "../../../services/userService";
import { toast } from "react-toastify";
import Loader from "../../../components/common/Loader";
import Cookies from "universal-cookie";
import {
  franchiseDelete,
  getFranchiseList,
  getSellerList,
  sellerDelete,
} from "../../../services/franchiseService";
import { DataGrid } from "@mui/x-data-grid";
import CustomPagination from "../../../components/common/dataGrid/CustomPagination";
import "../../../components/common/dataGrid/datagrid.scss";
import { Link, useNavigate } from "react-router-dom";
import { nameBasedProtectedRoutes } from "../../../router/protected";
import DeleteModal from "../../../components/common/DeleteModal";
import {
  formatNumberWithTwoDecimals,
  truncateText,
  getSubscription,
  handleSelectAndPayClick,
  
} from "../../../helpers/helpersMethods";
import commonValue from "../../../constants/commonValue";
import moment from "moment";
import { styled } from "@mui/material/styles";
import storage from "../../../helpers/storage";
import PaymentModal from "../../../components/common/PaymentModal";
const customTheme = createTheme({
  typography: {
    fontFamily: '"DM Sans", sans-serif',
    htmlFontSize: 17,
  },
  palette: {
    primary: {
      main: "#17B0B2",
    },
    text: {
      primary: "#000000",
      secondary: "#777777",
    },
  },
});

export const AllSeller = () => {
  const [selectedValue, setSelectedValue] = useState("");
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const [rowPerPage, setRowPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortColumn, setSortColumn] = useState("id");
  const [sortDirection, setSortDirection] = useState("desc");
  const [loading, setLoading] = useState(true);
  const [userStatus, setUserStatus] = useState();
  const [data, setData] = useState([]);
  const [mutation, setMutation] = useState(true);
  const [totalPages, setTotalPages] = useState(0);
  const [totalReults, setTotalResults] = useState(0);
  const [sorting, setSorting] = useState([]);
  const cookies = new Cookies();
  const [deletestatus, setDeletestatus] = useState(false);
  const [deleteRecordId, setDeleteRecordId] = useState();
  const [show, setShow] = useState(false);
  const [subscription, setSubscription] = useState("");
  const [subscriptionShow, setSubscriptionShow] = useState(false);
  const StyledGridOverlay = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    "& .ant-empty-img-1": {
      fill: theme.palette.mode === "light" ? "#aeb8c2" : "#262626",
    },
    "& .ant-empty-img-2": {
      fill: theme.palette.mode === "light" ? "#f5f5f7" : "#595959",
    },
    "& .ant-empty-img-3": {
      fill: theme.palette.mode === "light" ? "#dce0e6" : "#434343",
    },
    "& .ant-empty-img-4": {
      fill: theme.palette.mode === "light" ? "#fff" : "#1c1c1c",
    },
    "& .ant-empty-img-5": {
      fillOpacity: theme.palette.mode === "light" ? "0.8" : "0.08",
      fill: theme.palette.mode === "light" ? "#f5f5f5" : "#fff",
    },
  }));

  function CustomNoRowsOverlay() {
    return (
      <StyledGridOverlay>
        <Box sx={{ mt: 1 }}>No Data Found</Box>
      </StyledGridOverlay>
    );
  }
  
  const columns = [
    {
      field: "sNo",
      headerName: "S. No.",
      editable: false,
      flex: 0.05,
      minWidth: 100,
    },
    {
      field: "logo",
      headerName: "Logo",
      editable: false,
      flex: 0.2,
      minWidth: 120,
      sortable: false,
      renderCell: (props) => (
        <div className="detailSideCol">
          <span>
            <img
              src={props.row.logo} // Assuming 'logo' contains the URL of the logo image
              alt={`Logo ${props.row.id}`}
              style={{ width: "100" }}
            />
          </span>
        </div>
      ),
    },
    {
      field: "owner_name",
      headerName: "Owner Name",
      editable: false,
      flex: 0.6,
      minWidth: 100,
      renderCell: (props) => truncateText(props.row.owner_name),
    },
    {
      field: "name",
      headerName: "Business Name",
      editable: false,
      flex: 0.6,
      minWidth: 100,
      renderCell: (props) => truncateText(props.row.name),
    },
    {
      field: "annual_revenue",
      headerName: "Average Gross Revenue ($)",
      editable: false,
      flex: 0.5,
      minWidth: 100,
      renderCell: (props) =>
        formatNumberWithTwoDecimals(props.row.annual_revenue),
    },
    {
      field: "asking_price",
      headerName: "Asking price ($)",
      editable: false,
      flex: 0.6,
      minWidth: 100,
      renderCell: (props) =>
        formatNumberWithTwoDecimals(props.row.asking_price),
    },
    {
      field: "date_opened",
      headerName: "Date Opened",
      editable: false,
      flex: 0.5,
      minWidth: 100,
      renderCell: (props) =>
        moment(props.row.date_opened).format(
          commonValue.commaSeparatedShowDateTime
        ),
    },
    {
      field: "is_payment_subscription",
      headerName: "Payment",
      editable: false,
      flex: 0.3,
      minWidth: 130,
      renderCell: (props) => {
        return props.row.is_payment_subscription == "yes" ? (
          <span className="greenColor">Paid</span>
        ) : (
          <Link
            className="redColor"
            onClick={() =>{
              setPaymentData({
                type: "seller",
                id: props.row.id,
                bussnessName: props.row.name,
                subscription_id: 2,
                redirect: nameBasedProtectedRoutes.paymentList.path,
              });
              setSubscriptionShow(true)
            }}
            // to={
            //   nameBasedProtectedRoutes.payment.path +
            //   "?type=seller&id=" +
            //   props.row.id
            // }
          >
            Pay Now
          </Link>
        );
      },
    },
    // {
    //   field: 'status',
    //   headerName: 'Status',
    //   editable: false,
    //   flex: 0.30,
    //   minWidth: 130,
    //   renderCell: (props) => { return <SwitchCell defaultChecked={props.row.status}
    //   onClick={() => statusToggle(props.row.id,props.row.status)} /> }
    // },
    {
      field: "action",
      headerName: "Action",
      editable: false,
      flex: 0.2,
      minWidth: 120,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (props) => {
        return (
          <ActionCell
            controlId="app/seller"
            isViewEnable={true}
            isEditEnable={true}
            isDeleteEnable={true}
            handleDeleteClick={() => deleteRow(props.row.id)}
            redirectID={props.row.id}
            rowData={props.row}
          />
        );
      },
    },
  ];

  // Change user status

  // Change user status
  const deleteRow = (id) => {
    if (id) {
      setDeleteRecordId(id);
    }
    setShow(true);
  };
  const handleClose = () => {
    setShow(false);
  };
  const handleSubscriptionClose = () => {
    setSubscriptionShow(false); 
  }

  const recordDelete = () => {
    if (deleteRecordId) {
      setLoading(true);
      setShow(false);
      sellerDelete(deleteRecordId).then(
        (resp) => {
          setTimeout(() => {
            setLoading(false);
            setShow(false);
            //toast.success(resp.msg);
            setCurrentPage(1);
            fetchList({ page: currentPage, limit: rowPerPage });
          }, 1000);
        },
        (error) => {
          const err = error?.response?.data;
          setLoading(false);
          setShow(false);
          if (err?.statusCode === 400) {
            //toast.error(err.msg);
            navigate(nameBasedProtectedRoutes.franchise.path);
          }
        }
      );
    }
  };

  // Searching and listing user list
  const handleValueChange = (value) => {
    setSelectedValue(value);
    setCurrentPage(1);
    fetchList({
      page: currentPage,
      limit: rowPerPage,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      ...(value ? { searchtext: value } : { searchtext: "" }),
    });
  };

  // Get user list details
  const fetchList = (params) => {
    toast.dismiss();
    setLoading(true);
    getSellerList({ ...params }).then(
      (response) => {
        console.log(response);
        const res = response?.data;
        const itemsPerPage = params?.limit || 10;
        const currentPage = params?.page || 1;
        const startIndex = (currentPage - 1) * itemsPerPage + 1;
        const dataWithSNo = res.record.map((item, index) => ({
          ...item,
          sNo: startIndex + index,
        }));
        setLoading(false);
        setData(dataWithSNo);
        setTotalPages(res.totalPages);
        setTotalResults(res.totalResults);
        setLoading(false);
      },
      (error) => {
        const err = error?.response?.data;
        setLoading(false);
        if (err?.statusCode === 400) {
          toast.error(err.msg);
        }
      }
    );
  };

  // On page load fetch user list
  useEffect(() => {
    fetchList({
      page: currentPage,
      limit: rowPerPage,
      searchtext: selectedValue,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
    });
  }, [page, rowPerPage, sortColumn, sortDirection, currentPage]);

  useEffect(() => {
    const subscriptionData = async () => {
      try {
        const subscriptionDetails = await getSubscription();
        setSubscription(
          subscriptionDetails ? subscriptionDetails.seller : ""
        );
        console.log('subscriptionDetails',subscriptionDetails);
      } catch (error) {
        // Handle any errors that occurred during the data retrieval
        console.error("Error fetching data:", error);
      }
    };
    subscriptionData();
  },[])

  const handlePageChange = (params) => {
    setCurrentPage(params.page + 1);
    setRowPerPage(params.pageSize);
  };
  const handlePageSizeChange = (params) => {
    setRowPerPage(params.pageSize);
  };
  //setPaymentData
  const setPaymentData = (data) => {
    if (data) {
      storage.clearPaymentData("payment-data");
      storage.setData("payment-data", data);
      // window.location.href = "stripe";
    }
  };

  return (
    <>
      <div className="d-flex flex-column pageContainer p-3 h-100">
        <div className="flex-grow-1 h-100 pageContent position-relative pt-4 overflow-auto">
          <Card className="h-100 bg-white shadow border-0 theme-card-cover">
            <div className="theme-card-header px-1">
              <Stack
                direction="horizontal"
                gap={2}
                className="flex-wrap justify-content-between px-3 pt-3 pb-2 align-items-start"
              >
                <h5 className="mb-0 position-relative fs-18 text-black fw-medium">
                  <div className="align-items-center bg-primary d-inline-flex h-60 justify-content-center  position-absolute rounded start-0 text-white theme-icon-box w-60 z-1">
                    <svg width="29.4" height="26.46" viewBox="0 0 29.4 26.46">
                      <path
                        id="Icon_material-business-center"
                        data-name="Icon material-business-center"
                        d="M14.76,23.61V22.14H4.485L4.47,28.02a2.93,2.93,0,0,0,2.94,2.94H27.99a2.93,2.93,0,0,0,2.94-2.94V22.14H20.64v1.47Zm14.7-13.23H23.566V7.44L20.626,4.5h-5.88l-2.94,2.94v2.94H5.94A2.949,2.949,0,0,0,3,13.32v4.41a2.93,2.93,0,0,0,2.94,2.94h8.82V17.73h5.88v2.94h8.82a2.949,2.949,0,0,0,2.94-2.94V13.32A2.949,2.949,0,0,0,29.46,10.38Zm-8.82,0H14.76V7.44h5.88Z"
                        transform="translate(-3 -4.5)"
                        fill="#fff"
                      />
                    </svg>
                  </div>
                  Business Seller List
                </h5>
                <Link
                  to={nameBasedProtectedRoutes.sellerAdd.path}
                  className="btn btn-primary"
                >
                  Add New
                </Link>

                {/* <Button variant="primary">Add Franchise</Button> */}
              </Stack>
            </div>
            <div className="flex-grow-1 d-flex flex-column px-3 h-100 overflow-auto">
              <div className="theme-data-table-filter px-1">
                <ThemeProvider theme={customTheme}>
                  <Row className="justify-content-end">
                    <Col sm={5} lg={2} className="mb-3 pb-1">
                      <TextField
                        id="search-filter"
                        label="Search"
                        variant="standard"
                        className="custom-text-field"
                        fullWidth
                        value={selectedValue}
                        onChange={(e) => {
                          handleValueChange(e.target.value);
                        }}
                      />
                    </Col>
                  </Row>
                </ThemeProvider>
              </div>

              {
                <div className="dataGridMain flex-fill px-1 w-100">
                  <DataGrid
                    slots={{
                      noRowsOverlay: CustomNoRowsOverlay,
                    }}
                    rows={data}
                    columns={columns}
                    pageSize={rowPerPage}
                    rowCount={totalReults}
                    onPageChange={handlePageChange}
                    onPageSizeChange={handlePageSizeChange}
                    onSortModelChange={(model) => {
                      // Extract the sorting information from the model
                      const sortField = model[0]?.field || sortColumn;
                      const sortDirection = model[0]?.sort || "asc";
                      setSortColumn(sortField);
                      setSortDirection(sortDirection);
                      // Update the state and fetch new data based on the sorting
                      setSorting(model);
                      // fetchList({
                      //   page,
                      //   limit: rowPerPage,
                      //   searchtext: selectedValue,
                      //   sortColumn: sortColumn,
                      //   sortDirection: sortDirection,
                      // });
                    }}
                    pageSizeOptions={[5, 10, 15, 20]}
                    initialState={{
                      pagination: {
                        paginationModel: {
                          page: currentPage - 1,
                          pageSize: rowPerPage,
                        },
                      },
                    }}
                    paginationMode="server"
                    onPaginationModelChange={handlePageChange}
                    disableColumnMenu
                  />
                </div>
              }
            </div>
          </Card>
        </div>
      </div>
      <Loader isLoading={loading} />
      <DeleteModal
        show={show}
        handleClose={handleClose}
        setDeletestatus={setDeletestatus}
        recordDelete={recordDelete}
      />
      <PaymentModal
        show={subscriptionShow}
        handleClose={handleSubscriptionClose}
        details={subscription}
        navigate={navigate}
        handleSelectAndPayClick={handleSelectAndPayClick}
      />
    </>
  );
};
